import React, { useState } from 'react';
import { Form, Input, Button, Card, message, ConfigProvider } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services';
import './Login.css';

const Login = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [form] = Form.useForm();

    const handleLogin = async (values) => {
        try {
            setLoading(true);
            const response = await authService.login(values.username, values.password);

            if (response.data.code === 200) {
                localStorage.setItem('token', response.data.data.token);
                localStorage.setItem('user', JSON.stringify(response.data.data.user));
                message.success('登录成功');
                navigate('/');
            } else {
                message.error(response.data.message || '登录失败');
            }
        } catch (error) {
            message.error(error.response?.data?.message || '登录失败，请稍后重试');
        } finally {
            setLoading(false);
        }
    };

    return (
        <ConfigProvider theme={{
            token: {
                fontFamily: '仿宋, serif'
            }
        }}>
            <div className="login-container">
                <Card className="login-card" title="道路交通事故管理">
                    <Form form={form} onFinish={handleLogin} layout="vertical">
                        <Form.Item
                            name="username"
                            rules={[{ required: true, message: '请输入用户名' }]}
                        >
                            <Input
                                prefix={<UserOutlined />}
                                placeholder="用户名"
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            rules={[{ required: true, message: '请输入密码' }]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder="密码"
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={loading} size="large" block>
                                登 录
                            </Button>
                        </Form.Item>
                    </Form>

                    {/* <div className="login-tip">
                        <p>默认账户：admin</p>
                        <p>默认密码：admin123</p>
                    </div> */}
                </Card>
            </div>
        </ConfigProvider>
    );
};

export default Login;
